import { Reducer } from 'redux';
import { OrganisationActionTypes, OrganisationState } from './types';

const initialState: OrganisationState = {
  currentUserOrganisation: undefined,
  isGettingUserOrganisation: false
};

const reducer: Reducer<OrganisationState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case OrganisationActionTypes.FETCH_USER_ORGANISATION_START: {
      return {
        ...state,
        isGettingUserOrganisation: true
      };
    }
    case OrganisationActionTypes.FETCH_USER_ORGANISATION_SUCCESS: {
      return {
        ...state,
        isGettingUserOrganisation: false,
        currentUserOrganisation: action.payload
      };
    }
    case OrganisationActionTypes.FETCH_USER_ORGANISATION_FAILURE: {
      return {
        ...state,
        isGettingUserOrganisation: false,
        currentUserOrganisation: {}
      };
    }
    default:
      return state;
  }
};

export { reducer as OrganisationReducer };
